module.exports = __webpack_public_path__ + "img/rewards.2c213c21.svg";